import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.css']
})
export class EmailComponent implements OnInit {

  email;
  password;



  constructor(
    private authService: AuthService,
    private router: Router) { }

  ngOnInit() {
  }

  onSubmit(formData) {
    if (formData.valid) {
      console.log(formData.value);
      this.authService.login(
        formData.value.email,
        formData.value.password
      )
      .then((res: any) => {
        console.log(res);
        if(res == '1'){
          this.router.navigateByUrl('/profile');
        }else{
          this.router.navigateByUrl('/documentos');
        }
      })
      .catch((error: any) => {  
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/email/email.component.ts